import React from "react";
import "../style/EconomicCalendar.css";
// import "../style/Footer.css";
// import Footer from "../components/Footer";



// const events = [
//     {
//       time: "13:15",
//       country: "🇫🇷",
//       title: "CPI (EU Norm) Final MM",
//       forecast: "-0.2%",
//       previous: "0.2%",
//     },
//     {
//       time: "13:15",
//       country: "🇫🇷",
//       title: "CPI (EU Norm) Final YY",
//       forecast: "1.8%",
//       previous: "1.8%",
//     },
//     {
//       time: "15:30",
//       country: "🇩🇪",
//       title: "ZEW Current Conditions",
//       forecast: "-90 Net balance",
//       previous: "-90.4 Net balance",
//     },
//     {
//       time: "15:30",
//       country: "🇩🇪",
//       title: "ZEW Economic Sentiment",
//       forecast: "20 Net balance",
//       previous: "10.3 Net balance",
//     },
//     {
//       time: "19:00",
//       country: "🇨🇦",
//       title: "Core CPI MM SA",
//       forecast: "",
//       previous: "0.3%",
//     },
//     {
//       time: "19:00",
//       country: "🇨🇦",
//       title: "CPI BoC Core YY",
//       forecast: "",
//       previous: "1.8%",
//     },
//     {
//       time: "19:00",
//       country: "🇨🇦",
//       title: "CPI Inflation YY",
//       forecast: "1.9%",
//       previous: "1.8%",
//     },
//   ];




const EconomicCalendar = () => {
    // const showFooterInMiddle = true;
  return (
    <div className="cal-container">
      {/* Economic Calendar Section */}
      <section className="cal-header">
        <div className="cal-header-content">
          <h1 className="cal-title">Economic Calendar</h1>
          <p className="cal-description">
          The economic calendar allows you to monitor
            market-moving events, including monetary
            policy decisions, scheduled events, news
            releases, and other economic indicators. These
            may be announced or released in a report and
            have a high possibility of moving the financial
            markets.
          </p>
        </div>
        <div className="cal-image">
          <img src="/images/cal1.png" alt="Economic Calendar" />
        </div>

        
      </section>

      <div className="texteco">
        <p>An important tool for short and long-term traders, and investors alike, the Extrede economic calendar can help you decide whether to stay on the sidelines or whether to load up and take a position, capitalising on news-driven volatility.</p>
      </div>







<div id="economical">

    <div className="economical">
        <p id="ecopara">16 February</p>
        {/* <  hr /> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>

    <br/>

  
    <div className="economical">
        <p id="ecopara">17 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>
    <br/>


    
    <div className="economical">
        <p id="ecopara">18 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>
    <br/>
    
    <div className="economical">
        <p id="ecopara">19 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>
    <br/>

    
    <div className="economical">
        <p id="ecopara">20 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>




    
    <div className="economical">
        <p id="ecopara">21 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>

    <div className="economical">
        <p id="ecopara">22 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>

    <div className="economical">
        <p id="ecopara">23 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>

    <div className="economical">
        <p id="ecopara">24 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>

    <div className="economical">
        <p id="ecopara">25 February</p>
        {/* <hr/> */}
        <div className="timetext">
            <div className="time">
               <p> 13.15</p>
            </div>
            <div className="timetext1">
                <p> CPI (EU NORMS) Final MM</p>
            </div>

        </div>

        <div className="network">
            <div className="afp">
                <div className="photo"><img src="/images/FR1.jpg" alt="france" /><i class="fa-solid fa-wifi"></i></div>
                <div className="a">A: -0.2%</div>
                <div className="f">F: -0.2%</div>
                <div className="f">P: -0.2%</div>
                {/* <div className="p">P: -0.2%</div> */}
            </div>
        </div>
    </div>


    </div>


    
      </div>
       
    );
  };
  
  export default EconomicCalendar;